import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from 'kepler/lib/components/Select';
import { SUB_TOPIC, SELECT_BOX_OPTIONS } from '../constants/PropTypesShapes';

class TopicSelection extends Component {
  constructor(props) {
    super(props);
    this.onTopicChange = this.onTopicChange.bind(this);
  }

  onTopicChange(value) {
    const selectedTopic = this.props.topics.filter((topic) => {
      if (topic.topicRefId === value) {
        return topic;
      }
      return null;
    });
    this.props.onChange(selectedTopic[0]);
  }

  render() {
    return (
      <Select
        value={this.props.value}
        options={this.props.options}
        label={this.props.label}
        placeholder={this.props.placeholder}
        onChange={this.onTopicChange}
      />
    );
  }
}
TopicSelection.propTypes = {
  topics: PropTypes.arrayOf(PropTypes.shape(SUB_TOPIC)),
  label: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  options: PropTypes.shape(SELECT_BOX_OPTIONS),
};

TopicSelection.defaultProps = {
  options: {},
  label: '',
  placeholder: '',
  value: '',
  topics: [],
};

export default TopicSelection;
